export default "__VITE_ASSET__CYenkhl7__"